import React from 'react';

type DashboardColumnProps = {
    widgets: {
        id: string;
        type: string;
    }[];
    widgetsObject: () => void;
};

const DashboardColumn = ({
    widgets = [], widgetsObject = () => {},
} : DashboardColumnProps) => (
    <>
        {widgets?.map((widget) => (
            <div key={widget?.id}>
                {widgetsObject()[widget?.type]}
            </div>
        ))}
    </>
);

export default DashboardColumn;
